/** agent-tips 懒加载：按 tip 拆 chunk（重复 import 由 Webpack 模块缓存处理） */

export const loadCouponExpireTip = () =>
  import(
    /* webpackChunkName: "agent-tip-coupon-expire" */
    './CouponExpireTip.vue'
  ).then((mod) => mod.default);

export const loadBrowseSilenceTip = () =>
  import(
    /* webpackChunkName: "agent-tip-browse-silence" */
    './BrowseSilenceTip.vue'
  ).then((mod) => mod.default);

export const loadPayFailTip = () =>
  import(
    /* webpackChunkName: "agent-tip-pay-fail" */
    './PayFailTip.vue'
  ).then((mod) => mod.default);

export const loadPaySuccessTip = () =>
  import(
    /* webpackChunkName: "agent-tip-pay-success" */
    './PaySuccessTip.vue'
  ).then((mod) => mod.default);

export const loadEntryGuideTip = () =>
  import(
    /* webpackChunkName: "agent-tip-entry-guide" */
    './EntryGuideTip.vue'
  ).then((mod) => mod.default);

export const loadEntryWakeTip = () =>
  import(
    /* webpackChunkName: "agent-tip-entry-wake" */
    './EntryWakeTip.vue'
  ).then((mod) => mod.default);
